import { render, staticRenderFns } from "./CertificateIconProgress.vue?vue&type=template&id=2c510b76"
import script from "./CertificateIconProgress.vue?vue&type=script&lang=js"
export * from "./CertificateIconProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports